import styled from 'styled-components';

import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const VehicleBlockRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
`;

export const VehicleHeading = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;

    .ids-action span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-transform: capitalize;
    }
`;

export const VehicleThumbnail = styled.div<{ theme: InterstateTheme }>`
    flex-shrink: 0;
    width: 4rem;
    height: 3rem;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.tokens.BaseColorGray100};
    border-radius: 4px;

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const VehicleDetails = styled.ul<{ theme: InterstateTheme }>`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem;
    margin: 0;
    padding: 0.25rem 0;
    list-style: none;
    font-size: 1rem;

    li + li::before {
        content: '';
        display: inline-block;
        width: 1px;
        height: 0.75rem;
        margin-right: 0.25rem;
        vertical-align: middle;
        background-color: ${({ theme }) => theme.tokens.BaseColorGray300};
    }
`;

export const VehicleActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem 1rem;
    min-height: 1.5rem;

    &:empty {
        display: none;
    }
`;
